module.exports = {
          srcSet: __webpack_public_path__ + "public/images/7293d7f2572b136b0d442f26433b6a29-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/7293d7f2572b136b0d442f26433b6a29-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/7293d7f2572b136b0d442f26433b6a29-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/7293d7f2572b136b0d442f26433b6a29-1774.jpg"},
          
          width: 1774,
          height: 887
        }